import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RenewalComponent } from './renewal.component';
import { MotorStepComponent } from './motor-step/motor-step.component';
import { MotorDetailComponent } from './motor-detail/motor-detail.component';
import { InsuranceCompareComponent } from './insurance-compare/insurance-compare.component';
import { PaymentDetailComponent } from './payment-detail/payment-detail.component';
import { QrBarcodeComponent } from "./qr-barcode/qr-barcode.component"
import { PaymentSummaryComponent } from './payment-summary/payment-summary.component';
import { PaymentCallbackComponent } from './payment-callback/payment-callback.component';
import { NonMotorDetailComponent } from './nonmotor-detail/nonmotor-detail.component';
import { NonMotorStepComponent } from './nonmotor-step/nonmotor-step.component';
import { PageErrorComponent } from './page-error/page-error.component';
import { AuthGuard } from '../register/line/guards/auth.guard'
const routes: Routes = [

  {
    path: '',
    component: RenewalComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'motor-step',
    component: MotorStepComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'motor-detail',
    component: MotorDetailComponent,
    canActivate:[AuthGuard]
  },
  {
    path: "payment-detail",
    component: PaymentDetailComponent,
    canActivate:[AuthGuard]
  },
  {
    path: "insurance-compare",
    component: InsuranceCompareComponent,
  },
  {
    path: "qr-barcode",
    component: QrBarcodeComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'payment-summary',
    component: PaymentSummaryComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'payment-callback/:paymentObj',
    component: PaymentCallbackComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'nonmotor-detail',
    component: NonMotorDetailComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'nonmotor-step',
    component: NonMotorStepComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'page-error',
    component: PageErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RenewalRoutingModule {}
